<template>
  <detailTemplate :classCustom="'detail-docs'">
    <template #content>
      <div
        class="back-icon border-radius__50 clickable flex-row flex__center"
        @click="backListPage()"
      >
        <i class="el-icon-back font-size__large"></i>
      </div>
      <div class="header flex-row">
        <el-tag v-if="hcCasePhonghop.status === 'DANGXULY'" size="mini" class="priority lv2">{{hcCasePhonghop.state}}</el-tag>
        <el-tag v-if="hcCasePhonghop.status === 'HOANTHANH'" size="mini" class="priority lv4">{{hcCasePhonghop.state}}</el-tag>
        <el-tag v-if="hcCasePhonghop.status === 'HUY'" size="mini" class="priority lv1">{{hcCasePhonghop.state}}</el-tag>
      </div>
      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div
            style="color: #007aff"
            class="font-size__large font-weight__bold margin-bottom-10 margin-top-10"
          >Yêu cầu đăng ký phòng họp đột xuất</div>
          <div class="margin-top-10">
            <span class="label-input">Đơn vị yêu cầu:</span>
            <span class="font-weight__bold">{{hcCaseMaster.requestDeptName}}</span>
          </div>
          <div class="margin-top-10 padding-bottom-10 flex-row has-border__bottom">
            <span class="label-input">Người yêu cầu:</span>
            <div class="flex-row flex__left margin-left-10">
              <span class="font-weight__bold">{{hcCaseMaster.requestUserFullname}}</span>
            </div>
            <span class="label-input margin-left-10">vào lúc:</span>
            <el-date-picker
              size="mini"
              class="input-none__border input-border__radius__0 padding-left-0 el-date-picker-bold"
              v-model="hcCaseMaster.createTime"
              placeholder="dd/mm/yyyy"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              :prefix-icon="' '"
              :readonly="true"
            ></el-date-picker>
          </div>

          <div class="form-info padding-right-10 padding-bottom-10">
            <el-form ref="form" inline-message>
              <div class="group__info margin-top-10 padding-bottom-10">
                <div class="content">
                  <div class="form-input">
                    <div
                      class="title font-size__medium font-weight__bold margin-bottom-10"
                    >THÔNG TIN YÊU CẦU</div>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Tiêu đề:</span>
                      <el-input
                        type="text"
                        class="input-border__bottom input-border__radius__0 input-font__bold"
                        v-model="hcCasePhonghop.meetingTitle"
                        size="mini"
                        :readonly="true"
                      ></el-input>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Nội dung cuộc họp:</span>
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 5}"
                        class="input-border__bottom input-border__radius__0"
                        v-model="hcCasePhonghop.meetingContent"
                        size="mini"
                        :readonly="true"
                      ></el-input>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Thời gian bắt đầu:</span>
                      <el-date-picker
                        size="mini"
                        class="input-border__bottom input-border__radius__0"
                        v-model="hcCasePhonghop.startTime"
                        :prefix-icon="' '"
                        type="datetime"
                        format="dd/MM/yyyy HH:mm"
                        :readonly="true"
                      ></el-date-picker>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Thời gian kết thúc:</span>
                      <el-date-picker
                        size="mini"
                        class="input-border__bottom input-border__radius__0"
                        v-model="hcCasePhonghop.endTime"
                        :prefix-icon="' '"
                        type="datetime"
                        format="dd/MM/yyyy HH:mm"
                        :readonly="true"
                      ></el-date-picker>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Thành phần tham dự:</span>
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 5}"
                        class="input-border__bottom input-border__radius__0"
                        v-model="hcCasePhonghop.otherInvolved"
                        size="mini"
                        :readonly="true"
                      ></el-input>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Độ quan trọng:</span>
                      <div>
                        <el-tag
                          v-model="hcCasePhonghop.criticalLevel"
                          size="mini"
                          :class="[
                              'margin-top-10',
                              'priority',
                              hcCasePhonghop.criticalLevel === 'QUANTRONG' ? 'lv1' : '',
                              hcCasePhonghop.criticalLevel === 'COLANHDAO' ? 'lv2' : '',
                              hcCasePhonghop.criticalLevel === 'KHONGLANHDAO' ? 'lv3' : '',
                          ]"
                        >
                          {{hcCasePhonghop.criticalLevel === 'QUANTRONG' ? 'Quan trọng': ''}}
                          {{hcCasePhonghop.criticalLevel === 'COLANHDAO' ? 'Có lãnh đạo': ''}}
                          {{hcCasePhonghop.criticalLevel === 'KHONGLANHDAO' ? 'Không có lãnh đạo': ''}}
                        </el-tag>
                      </div>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="services">
                      <span class="label-input">Dịch vụ chuẩn bị:</span>
                      <el-checkbox-group v-model="hcCasePhonghop.services" class="width__100">
                        <el-checkbox style="z-index: -1" label="NUOC">Nước</el-checkbox>
                        <el-checkbox style="z-index: -1" label="HOAQUA">Hoa quả</el-checkbox>
                        <el-checkbox style="z-index: -1" label="MAYCHIEU">Máy chiếu</el-checkbox>
                        <div class="flex-row">
                          <el-checkbox style="z-index: -1" label="TRUYENHINH">Hội nghị truyền hình</el-checkbox>
                        </div>
                      </el-checkbox-group>
                    </el-form-item>

                    <div
                      class="title font-size__medium font-weight__bold margin-bottom-10"
                    >THÔNG TIN PHÒNG HỌP</div>

                    <el-form-item class="custom-label__input width25" prop="roomId">
                      <span
                        :class="['label-input', actions.length < 1 ? '' : 'field-needed']"
                      >Phòng họp:</span>

                      <el-select
                        :disabled="actions.length < 1"
                        v-model="roomId"
                        placeholder="Chọn phòng"
                        class="style-fullWidth input-border__bottom input-border__radius__0 font-size__small placeholder-black"
                      >
                        <el-option
                          v-for="item in listRooms"
                          :key="item.id"
                          :label="item.roomName"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="note">
                      <span
                        :class="['label-input', actions.length < 1 ? '' : 'field-needed']"
                      >Ghi chú:</span>
                      <el-input
                        class="input-border__bottom input-border__radius__0"
                        v-model="note"
                        :placeholder="note"
                        size="mini"
                        :readonly="actions.length < 1"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </VuePerfectScrollbar>

      <div class="footer">
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">
            <el-button
              size="mini"
              class="addDocs color__blue btn-none__border"
              v-if="update !== null"
              @click="updateRoom"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Cập nhật
            </el-button>
            <el-button
              size="mini"
              class="addDocs color__red btn-none__border"
              v-if="cancel !== null"
              @click="cancelRequest()"
            >
              <i class="fas fa-times-circle font-size__small"></i>
              &nbsp;Hủy yêu cầu
            </el-button>
          </div>
        </div>
      </div>
    </template>
  </detailTemplate>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import hanhchinhService from "../../../services/hanhchinhService";
import { EventBus } from "../../../event-bus.js";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";

export default {
  name: "dangKyPhongHopDetailDx",
  mixins: [handleRequestErrorMixin],
  components: {
    VuePerfectScrollbar,
    detailTemplate: () => import("../../common/detail.vue"),
    Multiselect: () => import("vue-multiselect")
  },
  created() {
    this.getData();
    this.getAction();
  },
  computed: {
    caseMasterId() {
      return this.$route.params.id;
    }
  },
  watch: {
    caseMasterId() {
      this.getData();
      this.getAction();
    }
  },
  data() {
    return {
      criticalLevels: ["Quan trọng", "Có lãnh đạo", "Không có lãnh đạo"],
      hcCaseMaster: {},
      hcCasePhonghop: {},
      selectedRoom: null,
      actions: [],
      cancel: null,
      update: null,
      listRooms: [],
      note: null,
      roomId: null,
      meetingTitle: null,
      meetingContent: null,
      startTime: null,
      endTime: null,
      otherInvolved: null,
      criticalLevel: null,
      services: [],
      startDate: null,
      endDate: null
    };
  },

  methods: {
    backListPage() {
      this.$router.push({
        name: "adminstration-dx",
        query: this.$route.query,
        params: this.$route.params
      });
    },

    getData() {
      hanhchinhService.MeetingRoomDetail(this.caseMasterId).then(respone => {
        this.listRooms = [];
        this.hcCaseMaster = respone.data.hcCaseMaster;
        this.hcCasePhonghop = respone.data.hcCasePhonghop;
        this.selectedRoom = respone.data.selectedRoom;
        this.note = this.hcCasePhonghop.note;
        if (this.hcCasePhonghop.services) {
          this.hcCasePhonghop.services = this.hcCasePhonghop.services.split(",");
        }



        if (this.selectedRoom !== null) {
          this.roomId = this.selectedRoom.id;
          this.listRooms.push({
            id: respone.data.selectedRoom.id,
            roomName: respone.data.selectedRoom.roomName
          });
        }

        this.startDate = new Date(this.hcCasePhonghop.startTime).getTime();
        this.endDate = new Date(this.hcCasePhonghop.endTime).getTime();
        hanhchinhService
          .getListMeetingRoomFree(this.startDate, this.endDate, 'PHONG_HOP_DX')
          .then(respone => {
            if (respone.data.dataRoomFree.length > 0) {
              respone.data.dataRoomFree.forEach(item => {
                if (item.id !== this.roomId) {
                  this.listRooms.push({
                    id: item.id,
                    roomName: item.roomName
                  });
                }
              });
            }
          });
      });
    },

    getAction() {
      hanhchinhService.getAction(this.caseMasterId).then(respone => {
        this.actions = respone.data.actions;
        this.cancel = null;
        this.update = null;
        respone.data.actions.forEach(item => {
          if (item.actionCode === "huyyeucau") {
            this.cancel = item.actionCode;
          } else if (item.actionCode === "capnhat") {
            this.update = item.actionCode;
          }
        });
      });
    },

    cancelRequest() {
      if (!this.note) {
        return this.notify(
          "Lỗi",
          "Vui lòng nhập lý do trong mục ghi chú",
          "error",
          2000
        );
      }

      let submitForm = {
        caseMasterId: this.caseMasterId,
        note: this.note
      };

      this.$confirm("Bạn có chắc muốn hủy yêu cầu không?", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(() => {
        hanhchinhService
          .cancel(submitForm)
          .then(() => {
            this.notify(
              "Thông báo",
              "Hủy yêu cầu thành công",
              "success",
              2000
            );
            EventBus.$emit("eventCalled", {});
            this.backListPage();
          }).catch(error => this.commonHandleRequestError(error));
      });
    },

    updateRoom() {
      if (!this.roomId) {
        return this.notify(
          "Lỗi",
          "Vui lòng chọn phòng",
          "error",
          2000
        );
      }
      if (!this.note) {
        return this.notify(
          "Lỗi",
          "Vui lòng nhập ghi chú",
          "error",
          2000
        );
      }
      if (this.roomId === this.selectedRoom.id) {
        return this.notify(
          "Lỗi",
          "Vui lòng chọn phòng họp khác",
          "error",
          2000
        );
      }

      let submitForm = {
        caseMasterId: this.caseMasterId,
        roomId: this.roomId,
        note: this.note
      };

      this.$confirm("Bạn có chắc chắn muốn cập nhật phòng họp?", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(() => {
        hanhchinhService
          .updateRoom(submitForm)
          .then(() => {
            this.notify(
              "Thông báo",
              "Cập nhật yêu cầu phòng họp thành công",
              "success",
              2000
            );
            EventBus.$emit("eventCalled", {});
            this.backListPage();
          }).catch(error => this.commonHandleRequestError(error));
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/phonghop/PhongHopDx_Detail.vue